import { render, staticRenderFns } from "./LanguagePaperPrint.vue?vue&type=template&id=6c7cd349&scoped=true"
import script from "./LanguagePaperPrint.vue?vue&type=script&lang=js"
export * from "./LanguagePaperPrint.vue?vue&type=script&lang=js"
import style0 from "./LanguagePaperPrint.vue?vue&type=style&index=0&id=6c7cd349&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7cd349",
  null
  
)

export default component.exports